// update along with app/lib/enums/user_type.py
const UserType = {
  SCRAPER: 'SCRAPER',
  GDSN: 'GDSN',
  CUT_AND_DRY: 'CUT_AND_DRY',
  CUT_AND_DRY_DISTRIBUTOR: 'CUT_AND_DRY_DISTRIBUTOR',
  FSA: 'FSA',
  DISTRIBUTOR: 'DISTRIBUTOR',
  INFLUENCE_PLUS: 'INFLUENCE_PLUS',
};

const UserTypeOptions = [
  { value: UserType.SCRAPER, label: 'Scraper' },
  { value: UserType.GDSN, label: 'GDSN' },
  { value: UserType.CUT_AND_DRY, label: 'Cut and Dry' },
  { value: UserType.CUT_AND_DRY_DISTRIBUTOR, label: 'Cut and Dry Distributor' },
  { value: UserType.FSA, label: 'FSA' },
  { value: UserType.DISTRIBUTOR, label: 'Distributor' },
  { value: UserType.INFLUENCE_PLUS, label: 'Influence Plus' },
];

export { UserType, UserTypeOptions };
